<actions [actionstrip]="actions" (clickAction)="clickAction($event)"></actions>
